// src/routes/user.routes.js
import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from '../guards/authGuard';
import SuperAdminGuard from '../guards/superAdminGuard';

// Lazy load dashboard pages
const UserManagement = lazy(() => import('../pages/dashboard/userManagement'));
const UserActivityLogs = lazy(() => import('../pages/dashboard/userActivityLogs'));
const UserExport = lazy(() => import('../pages/dashboard/userExport'));

const userRoutes = {
  path: 'users',
  element: (
    <AuthGuard>
      <SuperAdminGuard>
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </SuperAdminGuard>
    </AuthGuard>
  ),
  children: [
    {
      path: '',
      element: <UserManagement />
    },
    {
      path: 'edit/:userId',
      element: <UserManagement mode="edit" />
    },
    {
      path: 'export',
      element: <UserExport />
    },
    {
      path: ':userId/activities',
      element: <UserActivityLogs />
    }
  ]
};

export default userRoutes;